export default __webpack_public_path__ + "static/megafon-f3fcb2cdd1ffc7d3c28547d50d1d2fa6.png";